import AdminRoleDialog from './admin-role-dialog.container';

export default AdminRoleDialog;
